// extracted by css-extract-rspack-plugin
export default {"empty":"empty-thNDeJ","ok":"ok-Juvl9Y","title":"title-qbRKXf"};